import { supabase } from '../lib/supabase';

const TABLE_NAME = 'letter_templates';

// Get all letter templates
export const getLetterTemplates = async () => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .order('template_type', { ascending: true });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching letter templates:', error);
    // Fallback to default templates if DB fetch fails
    return Object.values(getDefaultLetterTemplates());
  }
};

// Get a specific letter template by type
export const getLetterTemplate = async (templateType) => {
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .eq('template_type', templateType)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error(`Error fetching ${templateType} letter template:`, error);
    // Fallback to default template if DB fetch fails
    return getDefaultLetterTemplates()[templateType];
  }
};

// Create or update a letter template
export const saveLetterTemplate = async (templateData) => {
  try {
    // Check if template exists
    const { data: existing } = await supabase
      .from(TABLE_NAME)
      .select('id')
      .eq('template_type', templateData.template_type)
      .single();

    if (existing) {
      // Update existing template
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .update({
          header: templateData.header,
          footer: templateData.footer,
          body: templateData.body,
          updated_at: new Date().toISOString(),
        })
        .eq('id', existing.id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } else {
      // Create new template
      const { data, error } = await supabase
        .from(TABLE_NAME)
        .insert([templateData])
        .select()
        .single();

      if (error) throw error;
      return data;
    }
  } catch (error) {
    console.error('Error saving letter template:', error);
    throw error;
  }
};

// Get default letter templates (used if no custom template exists)
export const getDefaultLetterTemplates = () => {
  // Use the same default template for both estimate and invoice
  const defaultBody = '{{document_type}}\n\nBill To:\n{{client_name}}\n{{client_address}}\n{{client_city_state_zip}}\n\nDocument #: {{invoice_number}}\nDate: {{date}}\n\n{{items_table}}\n\n{{totals_section}}\n\n{{notes_section}}';
  
  return {
    estimate: {
      template_type: 'estimate',
      header: 'Menlo Atherton Glass\nThe Clear Choice',
      footer: '',
      body: defaultBody,
    },
    invoice: {
      template_type: 'invoice',
      header: 'Menlo Atherton Glass\nThe Clear Choice',
      footer: '',
      body: defaultBody, // Use same default as estimate
    },
  };
};
